import type { FC } from "react"
import { useQuery } from "@rocicorp/zero/react"
import {
	IconCheckOutline18 as Check,
	IconUserXmarkOutline18 as UserX,
} from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"
import { Avatar } from "@productlane/ui"
import { CommandItem } from "@productlane/ui/src/components/internal/command"
import { queries } from "@productlane/zero/queries"

import type { SharedFilterItemsProps } from "./types"
import { useThreadsFilterState } from "../threads-filter-state"

export const AssigneesFilterItems: FC<SharedFilterItemsProps> = ({
	onSelect,
}) => {
	const { assigneeIds, addAssignee, removeAssignee } = useThreadsFilterState()
	const [users] = useQuery(queries.users())

	return (
		<>
			<CommandItem
				onSelect={() => {
					if (assigneeIds.includes(null)) {
						removeAssignee(null)
					} else {
						addAssignee(null)
					}
					onSelect()
				}}
				key="unassigned"
			>
				<div className="flex w-full items-center gap-2">
					<UserX className="h-4 w-4 shrink-0" />
					<span className="flex-1 truncate">Unassigned</span>
					<Check
						className={cn("h-4 w-4 shrink-0", {
							"opacity-100": assigneeIds.includes(null),
							"opacity-0": !assigneeIds.includes(null),
						})}
					/>
				</div>
			</CommandItem>
			<hr className="my-2" />
			{users.map((user) => (
				<CommandItem
					onSelect={() => {
						if (assigneeIds.includes(user.id)) {
							removeAssignee(user.id)
						} else {
							addAssignee(user.id)
						}
						onSelect()
					}}
					key={user.id}
				>
					<div className="flex w-full items-center gap-2">
						<Avatar image={user.imageUrl} name={user.name ?? ""} size="xs" />
						<span className="flex-1 truncate">{user.name}</span>
						<Check
							className={cn("h-4 w-4 shrink-0", {
								"opacity-100": assigneeIds.includes(user.id),
								"opacity-0": !assigneeIds.includes(user.id),
							})}
						/>
					</div>
				</CommandItem>
			))}
		</>
	)
}
